import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {Router, NavigationEnd} from '@angular/router';
import {ToasterConfig} from 'angular2-toaster/angular2-toaster';
import {Store} from '@ngrx/store';
import * as wjcCore from '@mescius/wijmo';
import {LanguageService} from './i18n/language.service';

@Component({
    standalone: false,
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['../scss/vendors/toastr/toastr.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit {
    toasterconfig: ToasterConfig =
        new ToasterConfig({
            tapToDismiss: true,
            timeout: 5000,
            toastContainerId: 1
        });

    constructor(private router: Router, private store: Store<any>, private language: LanguageService) {
    }

    ngOnInit() {
        this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            window.scrollTo(0, 0);
            // ログイン画面に戻ったら (ログアウト) 前のユーザの言語設定には書き込まない
            if (evt.urlAfterRedirects.indexOf('/login') === 0) {
                this.language.clearUser();
            }
        });
        // ログインユーザが読み込まれたら、そのユーザの保存済み言語に切り替える
        this.store.select<any>('activePromotionFeature').subscribe((feature: any) => {
            if (wjcCore.isObject(feature) && wjcCore.isObject(feature.user) && feature.user.loaded) {
                this.language.useUser(feature.user.user);
            }
        });
    }

}
